module.exports = __webpack_public_path__ + "static/img/banner3.41e2f1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/banner3.jpg
// module id = hj1c
// module chunks = 1